/** @format */
import { rgba } from 'emotion-rgba';
import { css } from 'styled-components';

import { PopoutMenuProps } from './index';

/**
 * Base styles for the popout menu component
 */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    position: relative;
    display: inline-block;

    .menu-title {
        margin: 0 0 var(--layout-spacing-12);
        font-weight: 700;
    }

    .menu-ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .menu-li {
        margin: 0 0 0.6rem;

        &:last-of-type {
            margin-bottom: 0;
        }
    }

    .menu-link {
        font-weight: 300;
    }

    .menu-wrapper {
        width: 24rem;
        position: absolute;
        top: 100%;
        right: 50%;

        /* Adds extra space needed by triangle without onMouseLeave firing */
        padding-top: var(--layout-spacing-12);

        /**
         * 1. Half of menu width
         * 2. How far to the right the right side of the arrow is
         * 3. Half of the width of the arrow
         */
        margin-right: calc(-12rem + 9.5rem - 0.1875rem);
    }

    .menu {
        border-radius: 0.8rem;
        background: var(--colors-surface-primary);
        box-shadow: var(--effects-shadow-md);
        padding: 1.6rem;

        /* Includes the arrow in the shadow if supported by the browser */
        @supports (filter: drop-shadow(0 0 0 red)) {
            box-shadow: none;
            filter: drop-shadow(0 0.2rem 0.6rem ${rgba('#0b002b', 0.2)});
        }

        &::before {
            content: '';
            border-style: solid;
            border-width: 0 0.375rem 0.375rem 0.375rem;
            border-color: transparent transparent var(--colors-border-inverse)
                transparent;
            position: absolute;
            bottom: 100%;
            right: 2.5rem;
        }
    }

    .menu-trigger-path {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 24rem;
        height: 100%;
        pointer-events: none;

        path {
            pointer-events: all;
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The popout menu component styles
 *
 * @param {PopoutMenuProps} props The popout menu properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
export const styles = (props: PopoutMenuProps) => css`
    ${baseStyles}
`;
